import React from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import {
  makeStyles,
  Menu as MuiMenu,
  Fade,
} from '@material-ui/core';

const useStyles = (theme, cardProps = {}) => makeStyles(() => ({
  paper: {
    padding: 0,
    boxShadow: theme.shadows.light[4] || '',
    ...cardProps,
  },
}));

const Menu = ({
  theme,
  cardProps,
  children,
  onClose,
  ...props
}) => {
  const classes = useStyles(theme, cardProps)();

  return (
    <MuiMenu
      classes={classes}
      TransitionComponent={Fade}
      onClose={onClose}
      {...props}
    >
      {children}
    </MuiMenu>

  );
};

Menu.propTypes = {
  theme: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  children: PropTypes.any,
  cardProps: PropTypes.object,
};

Menu.defaultProps = {
  cardProps: {},
  children: null,
};

export default withTheme(Menu);
